/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeFileViewModel } from "../types/ScholarshipTypeFileViewModel.ts";

export const scholarshipTypeFileViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do documento.")),
  scholarshipTypeId: z.optional(
    z
      .number()
      .int()
      .describe("ID do tipo de bolsa ao qual o documento pertence."),
  ),
  description: z.string().describe("Nome do documento.").nullish(),
  instruction: z
    .string()
    .describe("Instruções de anexação do documento. Opcional.")
    .nullish(),
  templateFile: z
    .string()
    .describe("Nome do arquivo-modelo armazenado no blob. Opcional.")
    .nullish(),
  templateFileName: z
    .string()
    .describe("Nome original do arquivo-modelo. Opcional.")
    .nullish(),
  templateFileURL: z
    .string()
    .describe("URL temporária (SAS) para download do arquivo-modelo. Opcional.")
    .nullish(),
  isMandatory: z.optional(
    z.boolean().describe("Indica se o envio deste documento é obrigatório."),
  ),
  generateFormLink: z.optional(
    z
      .boolean()
      .describe("Indica se deve gerar link de formulário para o documento."),
  ),
  generateCandidatePortalLink: z.optional(
    z
      .boolean()
      .describe(
        "Indica se deve gerar link do portal do candidato para o documento.",
      ),
  ),
  active: z.optional(z.boolean().describe("Indica se o documento está ativo.")),
}) as unknown as ToZod<ScholarshipTypeFileViewModel>;
